/* stylelint-disable no-descending-specificity */
import React, { Component } from 'react';
import styled from 'styled-components';

import withI18n from '../../../../utils/withI18n';
import FlexBox from '../../../../components/FlexBox';
import SingleBlog from '../single-blog';
import Suspend from '../../suspend';

const Container = styled.div`
 font-size: 14px;
 color: #666;
 background: #f8f8f8;
 padding: 19px 10px 43px;
 flex-grow: 1;
`;

const Content = styled(FlexBox)`
  background: #fff;
  padding: 0 16px;
`;

type Props = {
  locale: string,
  info: Object,
};

export default
@withI18n
class BlogDetail extends Component<Props> {
  static defaultProps = {
    locale: 'en',
    info: {},
  };

  render() {
    const { locale, info } = this.props;

    return (
      <Container direction="column">
        <Content>
          <SingleBlog isDetail={true} info={info} locale={locale} />
        </Content>
        <Suspend />
      </Container>
    );
  }
}
